const getActiveElement = () => {
  try {
    return document.activeElement || document.body;
  } catch (e) {
    try {
      return document.body;
    } catch (e) {
      return null;
    }
  }
};

export default getActiveElement;
